var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"white--text",attrs:{"rounded":"","x-small":"","color":"black","max-width":_vm.maxWidth || _vm.defaultMaxWidth,"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }